import FastCash from './FastCash';

export default FastCash;
